import React from "react";
import { MenuItem, Typography, styled } from "@mui/material";
import { isMobile } from "react-device-detect";
import Menu from "@mui/material/Menu";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";

import {
  getSettingState,
  setCustomModal,
  setModalType,
} from "../../../../redux/features/settingSlice";
import ShareBtn from "./ShareBtn";
import LogoutBtn from "./LogoutBtn";
// import DeleteBtn from "./DeleteBtn";
import ThemeBtn from "./ThemeBtn";

const MenuNavbar = ({ anchorEl, setAnchorEl }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  let urlParams = location.pathname.split("/");
  const { userData, darkMode } = useSelector(getSettingState);
  const myProfile = urlParams[1] === "profile" && !urlParams[2];

  const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
    "& .MuiPaper-root": {
      top: "50px !IMPORTANT",
      left: isMobile ? 0 : "52% !IMPORTANT",
      fontSize: "18px !IMPORTANT",
      borderRadius: 8,
      marginTop: theme.spacing(1),
      minWidth: 180,
      maxWidth: 200,
      color: "black.main",
      border: "2px solid",
      borderColor: "black.main",
      boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
      "& .MuiMenu-list": {
        padding: "8px 0",
      },
    },
  }));

  const StyleMenuItem = styled(MenuItem)(({ theme }) => ({
    "&.MuiButtonBase-root": {
      fontSize: 18,
      padding: "12px",
      "&:active": { fontWeight: 600 },
      "&.MuiMenuItem-root:hover": {
        backgroundColor: darkMode ? "none" : theme.palette.whiteDisabled2.main,
      },
    },
  }));

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const handleReportModal = () => {
    setAnchorEl(null);
    dispatch(setCustomModal(true));
    dispatch(setModalType("Report"));
  };
  return (
    <StyledMenu
      id='demo-positioned-menu'
      aria-labelledby='demo-positioned-button'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      {urlParams[1] === "profile" && urlParams[2] === "erfan" && (
        <ThemeBtn StyleMenuItem={StyleMenuItem} setAnchorEl={setAnchorEl} />
      )}
      <ShareBtn StyleMenuItem={StyleMenuItem} setAnchorEl={setAnchorEl} />
      {!myProfile && urlParams[1] !== "about" && userData && (
        <StyleMenuItem onClick={handleReportModal}>
          <ErrorOutlineRoundedIcon sx={{ mb: "3px", mr: "8px" }} /> Report
        </StyleMenuItem>
      )}
      {userData && myProfile && (
        <StyleMenuItem onClick={() => navigate("/profile/editprofile")}>
          <ModeEditOutlineOutlinedIcon sx={{ mb: "3px", mr: "8px" }} /> Edit
          profile
        </StyleMenuItem>
      )}
      {myProfile && (
        <StyleMenuItem onClick={() => navigate("/terms")}>
          <GavelRoundedIcon sx={{ mb: "3px", mr: "8px" }} />
          <Typography noWrap sx={{ fontSize: "18px" }}>
            Terms and conditions
          </Typography>
        </StyleMenuItem>
      )}

      {myProfile && (
        <StyleMenuItem onClick={() => navigate("/about")}>
          <InfoOutlinedIcon sx={{ mb: "3px", mr: "8px" }} />
          About Azad
        </StyleMenuItem>
      )}
      {/* {myProfile && (
        <StyleMenuItem onClick={() => navigate("/application")}>
          <GetAppRoundedIcon sx={{ mb: "3px", mr: "8px" }} />
          Download app
        </StyleMenuItem>
      )} */}

      {/* {userData && myProfile && (
        <DeleteBtn StyleMenuItem={StyleMenuItem} setAnchorEl={setAnchorEl} />
      )} */}
      {userData && myProfile && (
        <LogoutBtn StyleMenuItem={StyleMenuItem} setAnchorEl={setAnchorEl} />
      )}
    </StyledMenu>
  );
};

export default MenuNavbar;
